import React from 'react';
import { useTranslation } from 'react-i18next';
import facebook from '../assets/facebook.svg';
import instagram from '../assets/instagram.svg';
import lang from '../assets/lang.svg';
import twitter from '../assets/twitter.svg';
import './footer.css'

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentlanguage = i18n.resolvedLanguage || 'en';

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return ( 
    <footer className='footer_section'>
      <div className='footer_inner'>
        <div className='footer_top'>
          <div className='footer_brand'>
            <div className='footer_logo'>Eventra</div>
            <div className='footer_text'>
              {t('footer.text')}
            </div>
            <div className='footer_socials'>
              <div className='footer_social'><img src={instagram} alt="" /></div>
              <div className='footer_social'><img src={twitter} alt="" /></div>
              <div className='footer_social'><img src={facebook} alt="" /></div>
            </div>
          </div>

          <div className='footer_links'>
            <div className='footer_column'>
              <div className='footer_heading'>{t('footer.nav_title')}</div>
              <a className='footer_link' href='#home'>{t('footer.nav_1')}</a>
              <a className='footer_link' href='#events'>{t('footer.nav_2')}</a>
              <a className='footer_link' href='#how-it-works'>{t('footer.nav_3')}</a>
              <a className='footer_link' href='#featured'>{t('footer.nav_4')}</a>
              <a className='footer_link' href='#booking'>{t('footer.nav_5')}</a>
              <a className='footer_link' href='#community'>{t('footer.nav_6')}</a>
              <a className='footer_link' href='#newsletter'>{t('footer.nav_7')}</a>
            </div>

            <div className='footer_column'>
              <div className='footer_heading'>{t('footer.support_title')}</div>
              <div className='footer_link'>{t('footer.support_1')}</div>
              <div className='footer_link'>{t('footer.support_2')}</div>
              <div className='footer_link'>{t('footer.support_3')}</div>
              <div className='footer_link'>{t('footer.support_4')}</div>
              <div className='footer_link'>{t('footer.support_5')}</div>
            </div>
          </div>
        </div>

        <div className='footer_bottom'>
          <div className='footer_copy'>{t('footer.copy')}</div>
          <div className='footer_lang'>
            <img src={lang} alt="" />
            <div className='footer_lang_switch'>
              <button className={currentlanguage === 'en' ? 'footer_lang_active' : 'footer_lang_item'} onClick={() => changeLanguage('en')} type='button'>EN</button>
              <button className={currentlanguage === 'ar' ? 'footer_lang_active' : 'footer_lang_item'} onClick={() => changeLanguage('ar')} type='button'>AR</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
   );
}
 
export default Footer;
